import { createComponent, ComponentProps } from '@/internals/utils';
export type ModalFooterProps = ComponentProps;

const ModalFooter = createComponent({ name: 'ModalFooter' });

export default ModalFooter;
